import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "col-12 bg-white rounded shadow mt-3 p-3 text-start py-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", { class: "text-start" }, "จัดการหน้าแรก", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "รูปภาพ 1", -1)
const _hoisted_8 = { class: "col-sm-12" }
const _hoisted_9 = { class: "col-sm-12 col-md-12 mb-3" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "col" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "รูปภาพ 2", -1)
const _hoisted_13 = { class: "col-sm-12" }
const _hoisted_14 = { class: "col-sm-12 col-md-12 mb-3" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "col-sm-12 col-md-12 mb-3 mt-5" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "รูปภาพ Landing", -1)
const _hoisted_19 = { class: "col-sm-12" }
const _hoisted_20 = { class: "col-sm-12 col-md-12 mb-3 mt-5" }
const _hoisted_21 = { class: "d-flex mb-5 justify-content-center mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JMUpload = _resolveComponent("JMUpload")!
  const _component_JMUploadImages = _resolveComponent("JMUploadImages")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_JMUpload, {
              folder: "media",
              modelValue: _ctx.doc.image1,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.doc.image1) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("img", {
              src: _ctx.imageUrl(_ctx.doc.image1),
              height: "200"
            }, null, 8, _hoisted_10)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_JMUpload, {
              folder: "media",
              modelValue: _ctx.doc.image2,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.doc.image2) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("img", {
              src: _ctx.imageUrl(_ctx.doc.image2),
              height: "200"
            }, null, 8, _hoisted_15)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_JMUploadImages, {
              modelValue: _ctx.doc.images,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.doc.images) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("a", {
            class: "btn btn-secondary bg-secondary",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)))
          }, "บันทึก")
        ])
      ])
    ])
  ]))
}